import { FC } from 'react';
import { Skeleton, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { StatisticCardShell } from './statistic-card-shell';

const StyledSkeletonHeader = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  height: theme.spacing(6),
  flexShrink: 0,
}));

const StyledSkeletonBody = styled(Stack)(({ theme }) => ({
  flex: 1,
  gap: theme.spacing(3),
  paddingTop: theme.spacing(1),
}));

/**
 * Skeleton placeholder for a statistic card while data is loading.
 * Mirrors the exact card shell dimensions so the layout does not shift.
 */
export const StatisticCardSkeleton: FC = () => {
  return (
    <StatisticCardShell>
      <StyledSkeletonHeader>
        <Skeleton variant="text" width={100} height={16} />
        <Skeleton variant="rounded" width={64} height={24} />
      </StyledSkeletonHeader>

      <StyledSkeletonBody>
        <Skeleton variant="rounded" width="60%" height={36} />
        <Skeleton variant="rounded" width="80%" height={14} />
        <Skeleton variant="rounded" width="70%" height={14} />
      </StyledSkeletonBody>
    </StatisticCardShell>
  );
};
